import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { GetOrderPendingInvoicingHistoryListInput } from './GetOrderPendingInvoicingHistoryListInput';
import { GetOrderPendingInvoicingHistoryListOutput } from './GetOrderPendingInvoicingHistoryListOutput';

export class GetOrderPendingInvoicingHistoryListService extends HttpServiceBase {

    handle = (input?: GetOrderPendingInvoicingHistoryListInput): Promise<Result<GetOrderPendingInvoicingHistoryListOutput>|null> => {
        const parameters = input ? this.objectToUrl(input) : '';
        const promise = this.http.get<Result<GetOrderPendingInvoicingHistoryListOutput>>(`${this.baseUrlSislogApi}/v2/order-pending-invoicing-history${parameters}`);
        return promise;
    }
}
